/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The state of the auth support:
 *   * ACTIVE
 *   * BLOCKED
 *   * REMOVED
 */
export enum AuthSupportState {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  REMOVED = 'REMOVED'
}
